import { render } from "./UserResults.vue?vue&type=template&id=77ea557a&scoped=true"
import script from "./UserResults.vue?vue&type=script&lang=js"
export * from "./UserResults.vue?vue&type=script&lang=js"

import "./UserResults.vue?vue&type=style&index=0&id=77ea557a&scoped=true&lang=css"

import exportComponent from "/home/marco/keyos-projects/esamiFinanza/webapp-esamifinanza/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-77ea557a"]])

export default __exports__